import { render, staticRenderFns } from "./heartLoader.vue?vue&type=template&id=254c6fbc&scoped=true&"
import script from "./heartLoader.vue?vue&type=script&lang=js&"
export * from "./heartLoader.vue?vue&type=script&lang=js&"
import style0 from "./heartLoader.vue?vue&type=style&index=0&id=254c6fbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254c6fbc",
  null
  
)

export default component.exports